import { createRequestActionTypes } from '../../helpers'

export const FETCH_SUGGESTED = createRequestActionTypes(
  'SUGGESTED_CONTENT',
  'FETCH'
)
